<div class="modal-content templateUploader">
  <div class="modal-body row">
    <div class="col-md-12 text-center">
      <ng-container *ngIf="imageUrl; else imageBlob">
        <img [src]="imageUrl" style="width: 100%" />
      </ng-container>
      <ng-template #imageBlob>
        <img [src]="imageFromBlob" style="width: 100%" />
      </ng-template>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" aria-hidden="true" (click)="closePreview()">
      Ok
    </button>
  </div>
</div>
